(function () {
	'use strict';
	angular.module('app.core')
		.controller('quickSightDashboard', quickSightDashboard);

	quickSightDashboard.$inject = ['$state','$rootScope', '$scope', 'storeService', 'leanTableConfigService', 'navigationService', '$experiments'];

	function quickSightDashboard($state, $rootScope, $scope, storeService, leanTableConfigService, navigationService, $experiments) {
		this.reportSettingsId = $state.params.id.trim();
		var reportSettingsId = this.reportSettingsId;
		var unsubscribe;
		var originalTitle;
		globalReportName = reportSettingsId;
		leanTableConfigService.setReportSettingsId(reportSettingsId);
		leanTableConfigService.getConfig(null, 'Data Health Dashboard', 'customer', null, storeService.getState().adminConfig.factory.id);

		function init() {
			$scope.dashboardView = _.cloneDeep(storeService.getState().reportSettings);
			$scope.model = storeService.getState().reportSettings;
			originalTitle = $scope.dashboardView.reportName;
			$scope.dashboardView['isEmbeddedDashboard'] = true;
			unsubscribe = storeService.subscribe(function() {
				var state = storeService.getState();
				if (state.previousAction.type === 'report-settings/fetch-error') {
					unsubscribe();
					storeService.loadMyViews(globalConfig.factory.id).then(function(response) {
						var state;
						var dashboards = response.data && response.data.filter(function (view) {
							return view.viewType === 'dashboards';
						});
						if (dashboards && dashboards.length) {
							state = navigationService.getStateForDashboard(dashboards[0]);
						} else {
							state = {sref: 'app.dashboard.new-dashboard'};
						}
						$state.go(state.sref, state.params);
					});
					return;
				}
				if (state.reportSettings.reportName !== originalTitle) {
					originalTitle = state.reportSettings.reportName;
					$scope.dashboardView = _.cloneDeep(state.reportSettings);
					$scope.model = state.reportSettings;
					$scope.dashboardView['isEmbeddedDashboard'] = true;
				}
			});
		}

		init();
	}
})();
